(function () {
    'use strict';

    angular
        .module('app')
        .component('login', {
            templateUrl: 'app/public/components/login/login.html',
            controller: LoginController,
            bindings: {
                libro: '<',
                foco: '<'
            }
        });

    /* @ngInject */
    function LoginController($state, $timeout, Auth, AlertService, ADMIN_PRINCIPAL) {
        var vm = this;

        vm.user = {};
        vm.rememberMe = false;

        if (vm.foco) {
            $timeout(function () {
                angular.element('.form-group:eq(0)>input').focus();
            });
        }

        vm.login = function () {
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function (data) {
                vm.authenticationError = false;
                $state.go(ADMIN_PRINCIPAL);
            }).catch(function () {
                AlertService.error("login.form.error.authentication");
            });
        }
    }

})();
